import {
  Component,
  ChangeDetectorRef,
  ViewEncapsulation,
  ViewChild,
  ElementRef,
  inject,
} from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MessageService } from 'primeng/api';
import html2pdf from 'html2pdf.js';
import { ToastModule } from 'primeng/toast';
import { APP_CONFIG } from '../../../../../core/app-config.token';
import { DataService } from '../../../../../core/services/data.service';
import { SeguimientoExpService } from '../../../services/subservices/seguimiento-exp.service';
import { SpinnerService } from '../../../../../core/services/loading.service';

declare const swal: any;

// 🔹 Interfaces para tipar bien los arreglos
interface ArrayExp {
  titulo_obs: string;
  num_obs: string;
  nroobs: string;
  obs: string[];
  norma: string[];
}

interface ArrayExp2 {
  titulo_obs?: string;
  num_obs?: string;
  nroobs: string;
  obs: string[];
  norma: string[];
}

@Component({
  selector: 'app-acta-exp',
  templateUrl: './acta-exp.component.html',
  styleUrls: ['./acta-exp.component.scss'],
  encapsulation: ViewEncapsulation.None, // 👈 esto hace que Angular no scopee el SCSS
  standalone: true,
  imports: [CommonModule, ToastModule],
})
export class ActaExpedienteComponent {
  cfg = inject(APP_CONFIG);


  public idsolicitud = 0;
  public fecha = '';
  public enlaceActa = 'acta-expediente?id=';
  public dataValidar: any;
  public dataId: any;
  public expediente_info_interno: any;
  public expediente_info: any = {}; // ✅ objeto vacío por defecto
  public isSuccess = true;
  public arreglo: ArrayExp[] = [];
  public arreglo2: ArrayExp2[] = [];
  public notas = '';
  public arrNotas: any;
  public encabezado = '';
  public firmadirector: any;
  public fechaActa: any;
  public propietario = '';
  public arquitecto = '';
  public rolx = '';
  public proyecto = '';
  public contenido_acta: any;
  public arrContenidoActa: any;
  public nroordinario = '';
  public tipocertificado = '';
  public asignacion = '';
  public folioInterno = '';
  public replegal = '';
  public ordeningreso = '';
  public direccion = '';
  public materia = '';
  public revisor: any;
  public infopdf: any;
  identity: any;
  token: any;
  firmaUrlArquitecto: string | null = null;
  firmaUrlDirector: string | null = null;
  firmadirectorsaltolinea: any;
  distribucion: any;
  tokenValue: any;

  @ViewChild('pdfContent', { static: false }) pdfContentRef!: ElementRef;

  constructor(
    private _router: Router,
    private dataService: DataService,
    private _seguimientoExpService: SeguimientoExpService,
    private _cd: ChangeDetectorRef,
    private spinner: SpinnerService,
    private messageService: MessageService,
  ) {
    this.spinner.show('Cargando...');

    this.tokenValue = sessionStorage.getItem('identity.token') || '';

    this.dataId = this.dataService.getDato();
    this.dataValidar = this._router.parseUrl(this._router.url);
    this.dataId = this.dataValidar.queryParams.idActa;
    if (this.dataId == '') {
      this.idsolicitud = 0;
    }
    this.idsolicitud = this.dataId;
    this._seguimientoExpService.get_acta_imprimir(this.idsolicitud, this.tokenValue).subscribe(
      (response: any) => {
        if ('token' in response && response.token === false) {
          this.spinner.show('Cerrando sesión...');

          sessionStorage.removeItem('identity.user');
          sessionStorage.removeItem('identity.token');

          this.spinner.hide();
          this._router.navigate(['/login']);
          return this.messageService.add({
            severity: 'warn',
            summary: "No se encontraron resultados.",
            life: 5000,
            detail: response.message,
          });
        }

        if (!response?.data?.actaObservaciones?.fechaFirma) {
          this.isSuccess = false;
          this.spinner.hide();
          return this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail:
              'No se encontraron datos para el acta, favor intente nuevamente',
          });
        }

        if (response.data.expediente) {
          this.isSuccess = true;
          this.expediente_info = response.data;
          this.convertFirmaArquitecto(this.expediente_info?.actaObservaciones?.firmas?.revisor?.png);
          this.convertFirmaDirector(this.expediente_info?.actaObservaciones?.firmas?.director?.png);
          this.spinner.hide();
          this.messageService.add({
            severity: 'success',
            summary: 'Datos cargados',
            detail: 'Datos cargados correctamente',
          });
          this._cd.detectChanges();
        } else {
          this.spinner.hide();
          this.isSuccess = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail:
              'No se encontraron datos para el acta, favor intente nuevamente',
          });
        }
      },
      (error: any) => {
        this.isSuccess = false;
        this.spinner.hide();
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail:
            'No se encontraron datos para el acta, favor intente nuevamente',
        });
      }
    );
  }


  convertFirmaArquitecto(firmaData: { data: number[]; type: string } | null) {
    if (!firmaData || !Array.isArray(firmaData.data)) return;

    const bytes = new Uint8Array(firmaData.data);
    const blob = new Blob([bytes], { type: 'image/png' }); // o el type real
    this.firmaUrlArquitecto = URL.createObjectURL(blob);
  }

  convertFirmaDirector(firmaData: { data: number[]; type: string } | null) {
    if (!firmaData || !Array.isArray(firmaData.data)) return;

    const bytes = new Uint8Array(firmaData.data);
    const blob = new Blob([bytes], { type: 'image/png' }); // o el type real
    this.firmaUrlDirector = URL.createObjectURL(blob);
  }

  volver() {
    this._router.navigate(['/'], {
      queryParams: { idSol: this.dataId },
    });
  }
  /* generar pdf */
  async getPDF(name = 'acta-expediente-' + this.idsolicitud) {
    this.spinner.show('Generando PDF...');
    await Promise.resolve();
    setTimeout(() => {
      this._cd.detectChanges();
      const prepared = prepareContentForPDF(this.pdfContentRef.nativeElement!);

      const options = {
        margin: [10, 0, 15, 0], // [top, left, bottom, right] en mm
        filename: name + ".pdf",
        image: { type: 'jpeg', quality: 0.95 },
        html2canvas: {
          scale: 2.5,
          useCORS: true
        },
        jsPDF: {
          unit: 'mm',
          format: [226, 374],
          orientation: 'portrait'
        }
      };
      (html2pdf as any)()
        .from(prepared)
        .set(options)
        .toPdf()
        .get('pdf')
        .then((pdf: any) => {
          const totalPages = pdf.internal.getNumberOfPages();
          const pageWidth = pdf.internal.pageSize.getWidth();
          const pageHeight = pdf.internal.pageSize.getHeight();

          const rightMargin = 10;
          const bottomMargin = 8;

          pdf.setFontSize(9);

          for (let i = 1; i <= totalPages; i++) {
            pdf.setPage(i);
            pdf.text(
              `Página ${i} de ${totalPages}`,
              pageWidth - rightMargin,
              pageHeight - bottomMargin,
              { align: 'right' }
            );
          }

          pdf.save(options.filename);
        });

      this.spinner.hide()
    }, 2000);

  }
}

function prepareContentForPDF(originalElement: HTMLElement): HTMLElement {
  const cloned = originalElement.cloneNode(true) as HTMLElement;

  const inputs = cloned.querySelectorAll('input.pdf-input');

  inputs.forEach((input) => {
    const value = (input as HTMLInputElement).value;
    const replacement = document.createElement('div');
    replacement.textContent = value;
    replacement.style.fontSize = '9pt';
    replacement.style.color = '#000';
    replacement.style.border = 'none';
    replacement.style.padding = '0';
    replacement.style.margin = '0';
    replacement.style.lineHeight = '25px';
    replacement.style.height = '25px';
    replacement.style.display = 'block';

    input.parentNode?.replaceChild(replacement, input);
  });

  const radios = cloned.querySelectorAll('.custom-radio');

  radios.forEach((radio) => {
    const isSelected = !!radio.querySelector('.text-x');

    const replacement = document.createElement('span');
    replacement.className = 'custom-radio';
    replacement.style.display = 'inline-block';
    replacement.style.width = '18px';
    replacement.style.height = '18px';
    replacement.style.border = '1px solid #000';
    replacement.style.backgroundColor = '#fff9c4';
    replacement.style.textAlign = 'center';
    replacement.style.lineHeight = '18px';
    replacement.style.fontSize = '12pt';
    replacement.textContent = isSelected ? 'X' : '';

    radio.replaceWith(replacement);
  });

  // 🔹 Watermark múltiple
  const watermark = cloned.querySelector('#watermark') as HTMLElement;

  if (watermark) {
    // Altura “teórica” de una página, en px (la de tu .pdf-template)
    const pageHeightPx = 1419;

    // Cuántas “páginas” ocupa el contenido
    const totalPages = Math.max(
      1,
      Math.ceil(cloned.scrollHeight / pageHeightPx)
    );

    // Queremos al menos 2 marcas por página, en posiciones 25% y 75%
    const offsetsDentroPagina = [15, 75];

    for (let page = 0; page < totalPages; page++) {
      for (const offset of offsetsDentroPagina) {
        const wmClone = watermark.cloneNode(true) as HTMLElement;

        // 0–100% = página 1, 100–200% = página 2, etc.
        const topPercent = page * 100 + offset;
        wmClone.style.top = `${topPercent}%`;

        cloned.appendChild(wmClone);
      }
    }
  }

  return cloned;
}

